import { BannerVariant } from 'src/app/shared/components/banner/banner.component'

// Scenarios for the Banners section: the real BannerComponent rendered over the
// application-overview backdrop. `html` drives an innerHTML body (outage); otherwise
// `lead` (bold) + `detail` compose the "signal bar" copy. The subscription banner uses its
// production copy verbatim; the outage body is illustrative, since production renders
// admin-authored HTML.
export interface BannerScenario {
  key: string
  label: string
  variant: BannerVariant
  dismissible: boolean
  lead?: string
  detail?: string
  html?: string
  actionText?: string
}

export function buildBannerScenarios(): BannerScenario[] {
  return [
    { key: 'none', label: 'None (no banner)', variant: 'info', dismissible: false },
    {
      key: 'subscription-expired',
      label: 'Subscription expired (warning)',
      variant: 'warning',
      dismissible: false,
      lead: 'Your Arpio subscription has expired.',
      detail:
        'You can still review and modify your account, but recovery points are not currently being captured and you are not able to execute tests or recoveries.',
      actionText: 'Renew subscription',
    },
    {
      key: 'outage',
      label: 'AWS outage (info)',
      variant: 'info',
      dismissible: false,
      html: 'AWS is reporting a service disruption in <b>us-east-1</b>. Backups and recoveries in the affected region may be delayed.',
    },
    // Variant showcase only — no production banner uses `critical` or `dismissible`
    // yet, so this exercises the remaining color set and the dismiss affordance.
    {
      key: 'critical-demo',
      label: 'Critical variant (demo, dismissible)',
      variant: 'critical',
      dismissible: true,
      lead: 'Critical variant.',
      detail: 'Illustrative copy for the danger color set and the dismiss affordance. Not a shipped banner.',
      actionText: 'Take action',
    },
  ]
}
